<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="scoreDataCreateForm" (change)="scoreDataCreateFormChange()"
        (submit)="scoreDataCreateFormSubmit()" enctype="multipart/form-data">
        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"CREATE_SCORE_DATA" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="button" class="btn btn-outline-secondary m-2 rounded-0"
                    routerLink="/scores-grades/scores-data-upload" *ngIf="!creating">
                    {{"CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                        class="fas fa-user-plus"></i>
                    {{"SAVE" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12">
                <div class="row bg-white border m-0 py-3 ">
                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-1">
                                <label class="font-bold"> {{ "COURSE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="subjectid" (change)="getAssUnits()">
                                    <option value="" [selected]="true">{{ "SELECT" | translate |
                                        titlecase
                                        }}</option>
                                    <option *ngFor="let field of courses" value="{{field.subjectid}}">
                                        {{(globals.lang == 'ar')? field.subjectNameAr :
                                        field.subjectNameEn}} - ({{field.subjectCode}})</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="scoreDataCreateForm.controls.subjectid.touched && scoreDataCreateForm.controls.subjectid.invalid && scoreDataCreateForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-1">
                                <label class="font-bold"> {{ "ASSESS_UNIT" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="sbjasesid">
                                    <option value="" [selected]="true">{{ "SELECT" | translate |
                                        titlecase
                                        }}</option>
                                    <option *ngFor="let field of coursesAssessUnits" value="{{field.id}}">
                                        {{
                                        (globals.lang == 'ar')? field?.subjAsesNameAr : field?.subjAsesNameEn
                                        }}
                                    </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="scoreDataCreateForm.controls.sbjasesid.touched && scoreDataCreateForm.controls.sbjasesid.invalid && scoreDataCreateForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"SCORES_FILE" | translate | titlecase }}</label>
                                <input type="file" class="form-control" formControlName="filename"
                                    (change)="changeFile($event)"
                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="scoreDataCreateForm.controls.filename.touched && scoreDataCreateForm.controls.filename.invalid && scoreDataCreateForm.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-1">
                                <label class="font-bold"> {{ "NOTE" | translate | titlecase }}</label>
                                <textarea class="form-control" formControlName="remarks"> </textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>
